var html = require('choo/html')

module.exports = function () {
  return html`
    <svg class="Goal-glyph" viewBox="0 0 1000 460">
      <path fill="currentColor" fill-rule="evenodd" d="M413 438.7v14l-.2.4v.7c.2 3.5 3 6.3 6.6 6.3H585c3.5 0 6.4-3 6.4-6.7v-16C684.4 407 753.8 331.6 769 240c.3-.3.3-.5.3-.6v-1c0-3.7-3-6.6-6.6-6.6H237c-3.8 0-6.8 3-6.8 6.6l.4 3C246.6 334 318 409.7 413 439M591 7c-2 3-53 76.2 1.2 135.3 24.8 27.2 22.6 51 15.6 67.3h34.7c7-24 4-54-24-84.6-40-43.6.4-102.5 1-103.4 5-6.6 2.5-15.2-5.5-19.2-7.8-4-18-2-22.8 4.8m-87.8 202.6H538c7-24 4.2-53.8-24-84.6-40-43.6.5-102.5 1-103.4 5-6.7 2.3-15.4-5.5-19.4-8-4-18-2-22.8 4.8-2.2 3-53 76.2 1 135.3 25 27.2 22.7 51 15.7 67.3M382 7.2c-2.2 3-53 76.2 1.2 135.3 24.8 27.2 22.6 51 15.6 67.3h34.7c7-24 4-53.8-24-84.6-40-43.6.4-102.5 1-103.4 4.7-6.7 2.2-15.4-5.6-19.4-8-4-18.5-2-23 4.8"/>
    </svg>
  `
}
